import React from 'react';
import { GlobeIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-line bg-surface px-4 py-12" data-id="element-99" data-mp="3gfsmscqd8umz">
      <div className="mx-auto max-w-4xl text-center" data-id="element-100" data-mp="3gh3q6bfwg0dk">
        <p className="inline-flex items-center gap-2 text-lg font-black uppercase tracking-wide text-gold" data-id="element-101" data-mp="32ovvcp86ejhi">
          🎀 Compra Digital Ya™
        </p>
        <p className="mt-3 font-bold text-zinc-100" data-id="element-102" data-mp="36n3grxdl48z1">
          El sistema de planificación N°1 para profesores de Gimnasia Rítmica en Argentina.
        </p>
        <p className="mt-2 text-sm font-medium text-zinc-400" data-id="element-103" data-mp="37fvf8oqf24t">
          Porque enseñar rítmica no debería costarte todos los domingos del año.
        </p>
        <div className="mt-7 flex flex-col items-center justify-center gap-3 text-sm font-medium text-zinc-300 sm:flex-row sm:gap-6" data-id="element-104" data-mp="3qd6sbhar3z0i">
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-smooth hover:text-gold" href="mailto:compradigitalyaa@gmail.com" data-id="element-105" data-mp="29ydvdx2r0y8b">
            <MailIcon aria-hidden="true" className="h-4 w-4" data-id="element-106" data-mp="3lalgfg6ys7uh" /> compradigitalyaa@gmail.com
          </a>
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-smooth hover:text-gold" href="https://www.compradigitalya.com" target="_blank" rel="noopener noreferrer" data-id="element-107" data-mp="3gbr0qn4amzel">
            <GlobeIcon aria-hidden="true" className="h-4 w-4" data-id="element-108" data-mp="82qsbsqetttq" /> www.compradigitalya.com
          </a>
        </div>
        <p className="mt-8 border-t border-line pt-6 text-xs font-medium text-zinc-500" data-id="element-109" data-mp="34gyblgf8z9p">
          © Compra Digital Ya™ 2026 — Todos los derechos reservados.
          <br data-id="element-110" data-mp="huwgsshgdt46" />
          Prohibida la reproducción y redistribución sin autorización expresa.
        </p>
        <p className="mt-6 text-sm font-bold italic text-gold" data-id="element-111" data-mp="cw34h3dwk85l">
          🎀 “La próxima clase puede ser la mejor que diste.”
        </p>
      </div>
    </footer>;
}